/** THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
export const SIZEICON = {
  'number-size-icon-small': '0.75rem',
  'number-size-icon-medium': '1rem',
  'number-size-icon-large': '1.25rem',
  'number-size-icon-xlarge': '1.5rem',
  'number-size-icon-2xlarge': '2rem',
  'number-size-icon-3xlarge': '2.5rem'
}
